// extracted by mini-css-extract-plugin
module.exports = {"discPlayer":"discPlayer_discPlayer__3BTEM"};